<template>
  <div class="footer">
    <div class="app-wrapper">
      <div class="lt">
        <div class="lt_top">
          <div class="logo">
            <img src="../../assets/logo.png" />
          </div>
          <div class="tit_mod">
            <img src="../../assets/footer_tit.png" />
            <p>
              指导单位：山东省退役军人事务厅
            </p>
            <p>
              主办单位：山东省烈士事迹编纂和宣传教育中心
            </p>
          </div>
        </div>
        <div class="lt_bottom">
          <p class="phone"><i></i>电话：0531-88937928</p>
          <p class="email"><i></i>邮箱：yljsccyw@163.com</p>
        </div>
      </div>
      <div class="rt">
        <div class="ewm_mod wx_ewm">
          <div class="ewm_img_box"><img src="../../assets/wx_ewm.png" /></div>
          <p>公众号</p>
        </div>
        <!-- <div class="ewm_mod dy_ewm">
          <div class="ewm_img_box"><img src="../../assets/dy_ewm.jpg" /></div>
          <p>抖音</p>
        </div> -->
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'FooterIndex',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background: url(../../assets/footer_bg.png) center no-repeat #eee8df;
  .bottom {
    height: 50px;
    background: #a72126;
  }
  .app-wrapper {
    padding: 35px 0 45px 0;
    overflow: hidden;
  }
  .lt {
    float: left;
    margin-top: 35px;
    .lt_top {
      display: flex;
      justify-content: space-between;
      .logo {
        width: 88px;
        height: 88px;
        margin-right: 12px;
        img {
          width: 100%;
        }
      }
      .tit_mod {
        flex: 1;
        img {
          max-width: 100%;
        }
        p {
          font-size: 14px;
          margin-top: 10px;
          color: #666666;
        }
      }
    }
    .lt_bottom {
      margin-top: 40px;
      display: flex;
      p {
        display: flex;
        font-size: 14px;
        color: #666666;
        line-height: 30px;
        margin-right: 30px;
        i {
          display: block;
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }
      .phone i {
        background: url(../../assets/icon/phone.png) no-repeat;
      }
      .email i {
        background: url(../../assets/icon/email.png) no-repeat;
      }
    }
  }
  .rt {
    float: right;
    display: flex;
    .ewm_mod {
      height: 190px;
      border-radius: 10px;
      padding: 10px 6px;
      box-sizing: border-box;
      text-align: center;
      .ewm_img_box {
        background: #ffffff;
        width: 136px;
        height: 136px;
        border-radius: 10px;
        padding: 6px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        display: inline-block;
        line-height: 22px;
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 10px;
        padding-left: 27px;
      }
    }
    .wx_ewm {
      background: #a72126;
      margin-right: 30px;
      p {
        background: url(../../assets/icon/wx.png) no-repeat;
      }
    }
    .dy_ewm {
      background: #1c0b1b;
      p {
        background: url(../../assets/icon/douyin.png) no-repeat;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .footer .lt .lt_top .logo {
    margin-right: 10px;
  }
  .footer .lt {
    padding: 0 10px;
    float: none;
    .lt_bottom {
      display: block;
      margin-top: 20px;
      margin-left: 98px;
      p {
        margin-bottom: 10px;
      }
    }
  }
  .footer .rt {
    float: none;
    width: 100%;
    text-align: center;
    .ewm_mod {
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/footer.vue